import * as tslib_1 from "tslib";
import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import axios from 'axios';
var AiModelComponent = /** @class */ (function () {
    function AiModelComponent(dialogData) {
        this.dialogData = dialogData;
        this.requestBody = null;
        this.data = null;
        this.isLoading = false;
        this.hasError = false;
        this.errorMessage = '';
        this.activeCategory = 'all';
        if (this.dialogData) {
            this.requestBody = this.dialogData;
        }
    }
    AiModelComponent.prototype.ngOnInit = function () {
        console.log('AiModelComponent initialized with requestBody:', this.requestBody);
        if (this.requestBody) {
            this.fetchAssessmentData();
        }
    };
    AiModelComponent.prototype.ngOnChanges = function (changes) {
        if (changes['requestBody'] && !changes['requestBody'].firstChange && this.requestBody) {
            this.fetchAssessmentData();
        }
    };
    AiModelComponent.prototype.fetchAssessmentData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, err_1, errorObj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.requestBody) {
                            console.warn('AiModelComponent: No requestBody provided.');
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        this.hasError = false;
                        this.errorMessage = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        console.log('Sending Telemetry Request:', this.requestBody);
                        return [4 /*yield*/, axios.post('http://localhost:8000/predict', this.requestBody, {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        console.log('Telemetry Assessment Response:', response.data);
                        this.data = response.data;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Failed to fetch telemetry assessment:', err_1);
                        this.hasError = true;
                        errorObj = err_1;
                        if (errorObj && errorObj.response && errorObj.response.data && errorObj.response.data.message) {
                            this.errorMessage = errorObj.response.data.message;
                        }
                        else {
                            this.errorMessage = 'Failed to load telemetry assessment. Please try again.';
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AiModelComponent.prototype, "violationsList", {
        /**
         * Retrieves overall global violations across all IEC categories
         */
        get: function () {
            if (this.data &&
                this.data.iecAssessment &&
                this.data.iecAssessment.overall &&
                this.data.iecAssessment.overall.violations) {
                return this.data.iecAssessment.overall.violations;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Helper function to safely extract array length without optional chaining
     */
    AiModelComponent.prototype.getViolationsCount = function (categoryObj) {
        if (categoryObj && categoryObj.violations && Array.isArray(categoryObj.violations)) {
            return categoryObj.violations.length;
        }
        return 0;
    };
    Object.defineProperty(AiModelComponent.prototype, "iecCategories", {
        /**
         * Dynamic Category Builder: Extracts all IEC categories safely
         */
        get: function () {
            var iec = (this.data && this.data.iecAssessment) ? this.data.iecAssessment : null;
            var globalViolationsCount = this.violationsList.length;
            var baseCategories = [
                { key: 'all', label: 'All Categories', data: iec ? iec.overall : null, violationsCount: globalViolationsCount },
                { key: 'thermal', label: 'Thermal', data: iec ? iec.thermal : null, violationsCount: this.getViolationsCount(iec ? iec.thermal : null) },
                { key: 'electrical', label: 'Electrical', data: iec ? iec.electrical : null, violationsCount: this.getViolationsCount(iec ? iec.electrical : null) },
                { key: 'oil', label: 'Oil Health', data: iec ? iec.oil : null, violationsCount: this.getViolationsCount(iec ? iec.oil : null) },
                { key: 'environment', label: 'Environment', data: iec ? iec.environment : null, violationsCount: this.getViolationsCount(iec ? iec.environment : null) },
                { key: 'loading', label: 'Loading', data: iec ? iec.loading : null, violationsCount: this.getViolationsCount(iec ? iec.loading : null) },
                { key: 'protection', label: 'Protection', data: iec ? iec.protection : null, violationsCount: this.getViolationsCount(iec ? iec.protection : null) }
            ];
            return baseCategories;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AiModelComponent.prototype, "categories", {
        // Alias getter for backward compatibility
        get: function () {
            return this.iecCategories;
        },
        enumerable: true,
        configurable: true
    });
    AiModelComponent.prototype.setActiveCategory = function (categoryKey) {
        this.activeCategory = categoryKey;
    };
    /**
     * Status-to-Hex mapper supporting cyber visual themes
     */
    AiModelComponent.prototype.getColorHex = function (colorString) {
        if (!colorString)
            return '#94a3b8';
        var normalized = colorString.toLowerCase();
        switch (normalized) {
            case 'green':
            case 'lime':
            case 'normal':
            case 'good':
            case 'low':
            case 'stable':
                return '#30d158';
            case 'yellow':
            case 'orange':
            case 'warning':
            case 'medium':
                return '#ffcc00';
            case 'red':
            case 'critical':
            case 'high':
            case 'immediate':
                return '#ff3b30';
            case 'cyan':
                return '#00f0ff';
            default:
                return colorString.indexOf('#') === 0 ? colorString : '#94a3b8';
        }
    };
    AiModelComponent.prototype.getStatusColor = function (status) {
        return this.getColorHex(status);
    };
    return AiModelComponent;
}());
export { AiModelComponent };
